export const FETCH_RELEASE_ALBUM_REQUEST    =   'FETCH_RELEASE_ALBUM_REQUEST '
export const FETCH_RELEASE_ALBUM_FAILURE   =   'FETCH_RELEASE_ALBUM_FAILURE '
export const FETCH_RELEASE_ALBUM_SUCCESS    =   'FETCH_RELEASE_ALBUM_SUCCESS '
